// @flow
import { DelayedRedirect } from "views/components/common/DelayedRedirect";
import { Redirect } from "react-router-dom";
import { RouteProvider } from "views/components/Provider";
import { Spinner } from "views/mobile/components/common";
import { formatDatetime, minDiff } from "lib/date";
import { pathOr } from "ramda";
import { useQuery } from "hooks/useQuery";
import { useState } from "react";
import { useUpdateUserInfo } from "state/users/hooks";
import React, { useDispatch, useEffect, useGlobal } from "reactn";
import moment from "moment";
import { useAuth } from "hooks/useAuth";
import { ErrorMessage } from "views/components/Message";
import { useReservations } from "state/reservations/hooks";
import { useHistory } from "react-router-dom";
import { dinamicUrl } from "../../state/api";
import { useGetReservationById } from "hooks/useGetReservationById";
import { getReservationCode } from "../../lib/helpers/reservation";

import { useParams } from "react-router-dom";

const ReserveScreen = ({ match, children }) => {
	const [officeSlug, setOfficeSlug] = useState(null);
	const history = useHistory();
	const getLines = useDispatch("requestLines");

	const [user] = useGlobal("user");
	const [offices] = useGlobal("offices");

	const { status } = useParams();
	const query = useQuery();

	const data = query.get("data");

	const reserveInfo = data ? JSON.parse(atob(data)) : null;

	const reserveStatus =
		status === "confirmed"
			? "userConfirmed"
			: status === "canceled"
			? "userCanceled"
			: "userConfirmed";

	const selectedOffice = pathOr("", [reserveInfo.office.slug], offices);

	const timezone = pathOr("America/Santiago", ["timezone"], selectedOffice);

	const activeMeetButton =
		reserveInfo &&
		reserveInfo.from &&
		minDiff(reserveInfo.from, -15, timezone);

	const name = pathOr("", ["line", "name"], reserveInfo);

	useEffect(() => {
		if (!user.token) return;
	}, [user.token]);

	const goToMeet = (reservationId) => {
		window.open(`https://meet.zeroq.cl/${reservationId}`);
	};
	useEffect(() => {
		officeSlug && getLines({ officeSlug });
	}, [officeSlug]);

	const userConfirmed = pathOr(false, ["confirmed"], reserveInfo);

	if (!selectedOffice || !reserveInfo) return <Spinner full />;

	return children({
		reserve: reserveInfo,
		code: getReservationCode(reserveInfo),
		userConfirmed,
		selectedOffice,
		reserveStatus,
		goToMeet,
		name,
		activeMeetButton,
	});
};

export default RouteProvider(ReserveScreen);
